const sourceProperties = new WeakMap()
const sourceText = new WeakMap()
const textProperties = ['headerText', 'submitButtonText', 'label', 'placeholder']

// Amplify's legacy web components do not subscribe to I18n language changes.
// Refresh their public text properties, preserving the component and input state.
export function refreshAuthLanguage(root, translate) {
  for (const element of root.querySelectorAll('*')) {
    // Some older children expose no text property (for example reset links).
    // Only library UI text nodes are touched, never input values or auth data.
    for (const node of element.childNodes || []) {
      if (node.nodeType !== 3 || !node.nodeValue.trim()) continue
      const previous = sourceText.get(node)
      const original = previous && previous.translated === node.nodeValue ? previous.original : node.nodeValue
      const translated = translate(original)
      sourceText.set(node, { original, translated })
      if (node.nodeValue !== translated) node.nodeValue = translated
    }
    if (element.localName.startsWith('amplify-')) {
      const sources = sourceProperties.get(element) || {}
      for (const key of textProperties) {
        const value = element[key]
        if (typeof value !== 'string' || !value) continue
        const previous = sources[key]
        const original = previous && previous.translated === value ? previous.original : value
        const translated = translate(original)
        sources[key] = { original, translated }
        if (translated !== value) element[key] = translated
      }
      sourceProperties.set(element, sources)
    }
    if (element.shadowRoot) refreshAuthLanguage(element.shadowRoot, translate)
  }
}
